/* Tråden fra preloaderen i prototypen, uten ventetiden: en tynn oransje tråd
 * trekkes over toppen av skjermen mens siden kommer inn, og tones ut. Den
 * blokkerer ingenting, og vises bare ved første sidevisning i økten.
 *
 * Med «reduser bevegelse», uten JavaScript og i postermodus står elementet
 * skjult, slik CSS-en har det. */

import gsap from 'gsap';
import { $, mindreBevegelse } from './verktoy.js';

const NOKKEL = 'elp-traad-vist';

function alleredeVist() {
  try {
    if (sessionStorage.getItem(NOKKEL)) return true;
    sessionStorage.setItem(NOKKEL, '1');
  } catch {
    // Privat modus eller blokkert lagring: vis tråden, det er ufarlig.
  }
  return false;
}

export function startTraad() {
  const traad = $('.intro-traad');
  if (!traad || mindreBevegelse.matches || document.body.classList.contains('postermodus')) return;
  if (new URLSearchParams(location.search).has('poster') || alleredeVist()) return;

  const linje = $('i', traad);
  const hode = $('b', traad);
  traad.classList.add('i-gang');

  gsap.timeline({ onComplete: () => traad.remove() })
    .fromTo(linje, { clipPath: 'inset(0 100% 0 0)' },
      { clipPath: 'inset(0 0% 0 0)', duration: .9, ease: 'power2.inOut' }, 0)
    .fromTo(hode, { left: '0%', opacity: 0 },
      { left: '100%', opacity: 1, duration: .9, ease: 'power2.inOut' }, 0)
    .to(traad, { opacity: 0, duration: .45, ease: 'power2.out' }, '+=.05');
}
